import { useEffect, useState } from 'react'

import { useQuery } from 'react-query'
import { AxiosResponse } from 'axios'
import { GetItemsViewRequestOptions } from '../../types'
import { useAPI } from '../'
import { PATH } from '../../constants/global'

export default function (): UseItemsView {
   const request = useAPI()
   const [pageOptions, setPageOptions] = useState<ViewItemOptions>({
      Id: null,
      ToolLoanId: null,
      KitId: null,
      toolWarehouseId: null,
   })

   async function getItemsFromAPI(
      options: ViewItemOptions
   ): Promise<AxiosResponse<GetItemsViewRequestOptions[]>> {
      let { Id, ToolLoanId, KitId, toolWarehouseId } = options
      if (Id) {
         return request.get(
            `${PATH.ITEMS.LIST_VIEW}?Id=${Id}&ToolLoanId=${ToolLoanId}&KitId=${KitId}&toolWarehouseId=${toolWarehouseId}`
         )
      }
   }

   const { data, refetch, isLoading, isRefetching, isSuccess, remove } =
      useQuery<Promise<AxiosResponse>>('itemsListView', () =>
         getItemsFromAPI(pageOptions)
      )

   const getItemView = (options: ViewItemOptions) => setPageOptions(options)

   useEffect(() => {
      refetch()
   }, [pageOptions])

   useEffect(() => () => remove(), [])

   return {
      data: data ?? [],
      getItemView,
      isLoading,
      isRefetching,
      isSuccess,
      refetchItem: refetch,
   }
}
